import {
	DROP_EVENT_PAGE_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import { profileRouteMap } from 'root/src/shared/constants/route'

const ALLOWED_ROUTE_IDS = [DROP_EVENT_PAGE_ROUTE_ID]

export const isAllowedRoute = routeId => ALLOWED_ROUTE_IDS.includes(routeId)

// eslint-disable-next-line import/prefer-default-export
export const getAlternativeRouteIdByPlatform = ({ routeId, platform }) => {
	if (!ALLOWED_ROUTE_IDS.includes(routeId)) {
		return profileRouteMap[platform]
	}
	return routeId
}
